import {ATLAS_TMM_DB, REALTIME_DB} from '@/config/firebase';
import {child, get, ref, remove, set} from 'firebase/database';

export const getAllDiversion = (airline: string) => {
  return ref(REALTIME_DB, `${airline}/${ATLAS_TMM_DB}/diversion`);
};

export const addDiversion = async (
  airline: string,
  key: string,
  val: string
) => {
  const itemRef = ref(
    REALTIME_DB,
    `${airline}/${ATLAS_TMM_DB}/diversion/${key}`
  );
  const snapshot = await get(child(itemRef, key));

  if (!snapshot.exists()) {
    await set(itemRef, val);
  } else {
    throw new Error(`Key ${key} already exists`);
  }
};

export const removeDiversion = async (airline: string, key: string) => {
  const item = ref(REALTIME_DB, `${airline}/${ATLAS_TMM_DB}/diversion/${key}`);
  void remove(item);
};
